import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../shared/material.module';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NewEquipmentInspectionComponent } from './new-inspection/new-equipment-inspection/new-equipment-inspection.component';
import { NewInspectionService } from './inpsection.service';
import { ImplementInspectionSectionComponent } from './new-inspection/implement-inspection-section/implement-inspection-section.component';
import { PreInspectionChecklistComponent } from './interpretation/pre-inspection-checklist/pre-inspection-checklist.component';
import { MeasurementOnObservationComponent } from './new-inspection/implement-inspection-section/components/measurement-observation/measurement-on-observation.component';
import { ObservationQuestionsComponent } from './new-inspection/implement-inspection-section/components/observation-questions/observation-questions.component';
import { ObservationCommentsComponent } from './new-inspection/implement-inspection-section/components/observation-comments/observation-comments.component';
import { PhotosModalComponent } from './new-inspection/implement-inspection-section/components/photos-modal/photos-modal.component';
import { CommentPopupComponent } from './new-inspection/implement-inspection-section/components/observation-comments/comment-popup/comment-popup.component';
import { GETInterpretationComponent } from './interpretation/pages/interpretation.component';
import { ViewObservationPointRowComponent } from './new-inspection/implement-inspection-section/components/view-observation-point-row/view-observation-point-row.component';
import { GETSharedModule } from '../shared/shared.module';
import { ToastrModule } from 'ngx-toastr';
import { FecrNewPrePostShipmentInspectionComponent } from '../FECR/fecr-new-pre-post-shipment-inspection/fecr-new-pre-post-shipment-inspection.component';
import { GETPreferencesService } from '../preferences/preferences.service';
import { ViewComponentTypePointsComponent } from './new-inspection/implement-inspection-section/components/view-componenttype-points/view-componenttype-points.component';
import { ComponentImageHistoryButtonComponent } from '../../../shared/components/component-image-history/component-image-history-button.component';
import { ComponentImageHistoryComponent } from '../../../shared/components/component-image-history/component-image-history.component';
//import { SharedModule } from '../../../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    GETSharedModule,
    //SharedModule,
    ToastrModule.forRoot()
  ],
  declarations: [
    NewEquipmentInspectionComponent,
    ImplementInspectionSectionComponent,
    MeasurementOnObservationComponent,
    ObservationQuestionsComponent,
    ObservationCommentsComponent,
    PhotosModalComponent,
    CommentPopupComponent,
    GETInterpretationComponent,
    ViewObservationPointRowComponent,
    ViewComponentTypePointsComponent,
    PreInspectionChecklistComponent,
    FecrNewPrePostShipmentInspectionComponent,
    ComponentImageHistoryButtonComponent,
    ComponentImageHistoryComponent
  ],
  exports: [
    ImplementInspectionSectionComponent,
    PreInspectionChecklistComponent,
    FecrNewPrePostShipmentInspectionComponent,
    ComponentImageHistoryButtonComponent,
    ComponentImageHistoryComponent
  ],
  providers: [
    NewInspectionService,
    GETPreferencesService
  ]
})
export class GETInspectionModule { }
